import { getElementExists } from "../../../resources/js/helper/helper";

(function () {
  // Classes
  const centerplanContainerClass = ".com-centerplan";
  const centerplanControlClass = ".centerplan-control";
  const centerplanTextClass = ".floorplan__text";
  const centerplanTabClass = ".com-centerplan__wrapper";

  // Data-Attributes
  const tabActivData = "data-tab-active";
  const ariaExpanded = "aria-expanded";

  let documentWidth = document.body.clientWidth;

  /**
   * Setup centerplan
   */
  function setupAccodion() {
    const centerplanContainer = document.querySelectorAll(
      centerplanContainerClass
    );

    // For each centerplan-component
    for (let c = 0; c < centerplanContainer.length; c++) {
      let centerplanControls = centerplanContainer[c].querySelectorAll(
        centerplanControlClass
      );

      const centerplanTabs =
        centerplanContainer[c].querySelectorAll(centerplanTabClass);

      // for each centerplan tab
      for (let i = 0; i < centerplanControls.length; i++) {
        if (centerplanControls[i].hasAttribute(ariaExpanded)) {
          centerplanControls[i].addEventListener(
            "click",
            function (event) {
              onClickTab(i, centerplanControls, centerplanTabs);
            },
            false
          );
        }
      }
    }
  }

  /**
   * Function to toggle clicked tab and deactivate the other
   * @param {int / index} i
   * @param {array [Elements]} centerplanControls
   * @param {array [Elements]} centerplanTabs
   */
  function onClickTab(i, centerplanControls, centerplanTabs) {
    if (centerplanTabs == undefined || centerplanControls == undefined) {
      return false;
    }

    if (
      getElementExists(centerplanTabs[i]) &&
      centerplanTabs[i].getAttribute(tabActivData) == "false"
    ) {
      // Set Tab active
      centerplanTabs[i].setAttribute(tabActivData, "true");
      // centerplanControls[i].setAttribute("aria-expanded", "true");
      // centerplanControls[i].ariaExpanded = true;

      // Open content
      let tabInner = centerplanTabs[i].querySelector(centerplanTextClass);
      tabInner.setAttribute("aria-hidden", "false");
      // Set max-height by content height
      tabInner.style.maxHeight = tabInner.scrollHeight + "px";

      // Reset other tabs
      resetTabs(centerplanTabs, i);
    } else {
      // Reset active tab
      centerplanTabs[i].setAttribute(tabActivData, "false");
      // centerplanControls[i].setAttribute("aria-expanded", "false");
      // centerplanControls[i].ariaExpanded = false;

      centerplanTabs[i]
        .querySelector(centerplanTextClass)
        .setAttribute("aria-hidden", "true");

      let tabInner = centerplanTabs[i].querySelector(centerplanTextClass);
      tabInner.setAttribute("aria-hidden", "true");
      tabInner.style.maxHeight = 0;
    }
  }

  /**
   * Reset active tabs
   * @param {array[dom]} centerplanTabs
   * @param {int} keepActive
   */
  function resetTabs(centerplanTabs, keepActive) {
    centerplanTabs = centerplanTabs != null ? centerplanTabs : [];

    for (let i = 0; i < centerplanTabs.length; i++) {
      if (keepActive == null || i != keepActive) {
        if (!centerplanTabs[i].hasAttribute(tabActivData)) continue;
        centerplanTabs[i].setAttribute(tabActivData, "false");
        centerplanTabs[i]
          .querySelector(centerplanControlClass)
          .setAttribute("aria-expanded", "false");

        let tabInner = centerplanTabs[i].querySelector(centerplanTextClass);
        tabInner.setAttribute("aria-hidden", "true");
        tabInner.style.maxHeight = 0;
      }
    }
  }

  function resetTabsOnResize() {
    // Check for changing width (bugfix mobile browser)
    if (document.body.clientWidth !== documentWidth) {
      documentWidth = document.body.clientWidth;
      resetTabs(document.querySelectorAll(centerplanTabClass));
    }
  }

  window.addEventListener("resize", resetTabsOnResize);

  setupAccodion();
})();
